import axios from 'axios';
import router from 'next/router';
import { API_ORIGIN, API_PATH } from '~/config';

const apiUrl = new URL(API_PATH, API_ORIGIN);
const loginUrl = new URL('/login', API_ORIGIN);

export const apiClient = axios.create({
  baseURL: apiUrl.href,
  timeout: process.env.NODE_ENV === 'development' ? 1000000 : 10000,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      router.push(loginUrl);
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);
